module.exports = __webpack_public_path__ + "img/03_sub_no.bb78b38f.svg";